<template>
  <Box class="flex w-full flex-col gap-4">
    <div class="flex items-center gap-4">
      <div class="size-16 animate-pulse rounded bg-gray-30"></div>
      <div class="h-8 w-52 animate-pulse rounded bg-gray-30"></div>
    </div>
    <div class="flex flex-1 flex-col gap-4">
      <div class="h-8 w-full animate-pulse rounded bg-gray-30"></div>
      <div class="h-8 w-full animate-pulse rounded bg-gray-30"></div>
      <div class="h-8 w-full animate-pulse rounded bg-gray-30"></div>
      <div class="flex flex-1 items-end justify-end">
        <div class="h-11 w-28 animate-pulse rounded bg-gray-30"></div>
      </div>
    </div>
  </Box>
</template>

<script>
import Box from '@/components/ui/box';
export default {
  name: 'CardLoaderSmall',
  components: {
    Box,
  },
  props: {},
};
</script>
